<div id="editDevicePanel" class="customPanel">
  <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.editLuminary")}} {{selectedLumToEdit.idDispositivo}}
  </h1>

  <div mat-dialog-content class="bodyForm" style="display: grid">

    <div class="row rowForm textS+">
      <div class="col-6" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.name")}}</h5>
        <input id="inputEditDeviceName" [(ngModel)]="name" type="text" class="inputWidth textS+" maxlength="50" />
      </div>


      <div class="col" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.installationDate")}}</h5>
        <input [ngModel]="installationDate | date:'yyyy-MM-dd'"
               (ngModelChange)="installationDate = $event"
               type="date" class="inputWidth textS+">
      </div>

      <div class="col" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.consumptionHour")}}</h5>
        <input (input)="maxLengthCheck($event)" [(ngModel)]="consumoPorHora" type="number" step="0.001" class="textS+" style="width: 40%" max="999999"> kW
      </div>

    </div>

    <div class="row rowForm textS+">

      <div class="col" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.serialNumber")}}</h5>
        <input [(ngModel)]="serialNumber" type="text" class="inputWidth textS+" maxlength="10">
      </div>

      <div class="col-3" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.modelLed")}}</h5>
        <mat-form-field style="width: 90%;" color="primary" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.modelLed")}}</mat-label>
          <mat-select class="textS+" [(ngModel)]="modelLed">
            <mat-option *ngFor="let model of getModelList()"
                        [value]="model.id">{{model.id}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.lux")}}</h5>
        <input (input)="maxLengthCheck($event)" [(ngModel)]="lux" type="number" step="1" class="inputWidth textS+" max="999999">
      </div>

      <div class="col" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.hasEmergency")}}</h5>
        <input [(ngModel)]="hasEmergency" type="checkbox" class="inputWidth customCheck">
      </div>

    </div>

    <div class="row rowForm textS+">

      <div *ngIf="userService.getPermiso() == 'Administrador'" class="col-3" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.project")}}</h5>
        <mat-form-field style="width: 90%;" color="primary" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.project")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectProyecto($event)" [(ngModel)]="proyectoSelected">
            <mat-option *ngFor="let proyecto of user.getProyectos()"
                        [value]="proyecto">{{proyecto.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.floorplan")}}</h5>
        <mat-form-field style="width: 90%;" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.floorplan")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected">
            <mat-option *ngFor="let plano of showPlanos"
                        [value]="plano">{{plano.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3" style="margin: auto">
        <h5 class="textS+">{{this.localiser.get("devices.zone")}}</h5>
        <mat-form-field style="width: 90%;" color="warn" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.zone")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectZona($event)" [(ngModel)]="zonaSelected">
            <mat-option *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="userService.getPermiso() == 'Administrador'" class="col-3" style="text-align: center; margin:auto">
        <button style="top: 30%; width: 70%" class="customButtonColor textS" mat-button (click)="removeLocation()"
                [disabled]="proyectoSelected == null || proyectoSelected == undefined">
          <h3 class="textS" style="margin: 3%; color: black;">{{this.localiser.get("devices.removeLocation")}}</h3>
        </button>
      </div>

    </div>

    <div class="row">
      <h3 *ngIf="changingProyecto" class="textS+" style="color: #F2A356; text-align: center; margin: auto;">
        If you change the project, the luminarie will be removed from its groups
      </h3>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onSaveClick()">{{this.localiser.get("devices.save")}}</button>
    </div>
  </div>


</div>
